import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container h-100 pt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 text-center mb-3" }
const _hoisted_4 = { class: "text-center py-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "col-12 text-center mb-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Código de reserva", -1)
const _hoisted_8 = {
  class: "text-center py-3",
  style: {"line-break":"anywhere"}
}
const _hoisted_9 = { class: "col-12 text-center mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, " Enviamos por mail la confirmación de tu reserva y el código para participar de la actividad. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, " Deberás mostrar el mail el día de tu turno. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", {
  class: "text-center",
  "py-3": ""
}, "¡Te esperamos!", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, " Una vez confirmada enviaremos por mail la confirmación de tu reserva y el código para participar de la actividad. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, " Deberás mostrar el mail el día de tu turno. ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", {
  class: "text-center",
  "py-3": ""
}, "¡Te esperamos!", -1)
const _hoisted_16 = { class: "col-12 col-lg-6 text-center my-3" }
const _hoisted_17 = { class: "col-12 col-lg-6 text-center my-4 mb-lg-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInfoTitles = _resolveComponent("AppInfoTitles")!
  const _component_AppResumeComponent = _resolveComponent("AppResumeComponent")!
  const _component_AppButtonResetNav = _resolveComponent("AppButtonResetNav")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppInfoTitles),
      _createVNode(_component_AppResumeComponent, {
        logo: "/img/icons/checked.svg",
        title: "resumen.academy"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.state.navigation.datosPersonales.personal.nombreApellido), 1),
          _hoisted_5,
          _createTextVNode(" tu reserva quedó " + _toDisplayString(_ctx.state.navigation.datosPersonales.vip.isClient
              ? 'Confirmada!'
              : 'en estado pendiente de confirmación'), 1)
        ])
      ]),
      (_ctx.state.navigation.datosPersonales.vip.isClient)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.state.navigation.codigoReserva), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.state.navigation.datosPersonales.vip.isClient)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_10,
              _hoisted_11,
              _hoisted_12
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_13,
              _hoisted_14,
              _hoisted_15
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_AppButtonResetNav)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_router_link, {
          tag: "button",
          to: {
            name: 'voucher_cancelar',
            params: { codigoReserva: _ctx.state.navigation.codigoReserva }
          },
          class: "btn btn-danger text-center d-inline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cancelar reserva ")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}